<template>
  <v-layout column wrap>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">LIST OF ACA FELLOW</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-2">
        <v-flex xs12 md1>
          <v-checkbox label="Is Yearly?" v-model="is_yearly"
                      @change="get_list_of_new_member_items"></v-checkbox>
        </v-flex>
        <v-flex xs12 md2>
          <v-select
            v-if="is_yearly"
            v-model="month_of"
            class="mx-3 pt-5"
            :items="month_of_items"
            item-value="year"
            item-text="year"
            label="Year Of"
            required
            @change="get_list_of_new_member_items"
            :rules="rules.combobox_rule"
          ></v-select>
          <v-select
            v-else
            v-model="month_of"
            class="mx-3 pt-5"
            :items="month_of_items"
            item-value="id"
            item-text="month_of"
            label="Month Of"
            required
            @change="get_list_of_new_member_items"
            :rules="rules.combobox_rule"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-simple-table dense>
        <template v-slot:top>
          <v-toolbar flat>
            <span class="headline">Total: {{totall}}</span>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <span class="headline" v-if="can_print">
                                                Print
                                                <v-icon
                                                  class="mr-2"
                                                  color="warning"
                                                  @click="print_data()"
                                                >
                                                {{icons.mdiPrinter}}
                                                </v-icon>
                                            </span>
          </v-toolbar>
        </template>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-uppercase">
              Year of
            </th>
            <th class="text-uppercase">
              ID
            </th>
            <th class="text-uppercase">
              Name
            </th>
            <th class="text-center text-uppercase">
              Contact #
            </th>
            <th class="text-center text-uppercase">
              Amount
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in member_items"
            :key="item.id"
          >
            <td>
              <v-chip color="info" dark>
                {{ item.year_of}}
              </v-chip>
            </td>
            <td>
              {{ item.member?item.member.cmf_no:(item.district?item.district.id:(item.organization?item.organization.id:'')) }}
            </td>
            <td>
              {{ item.member?item.member.last_name+', '+item.member.first_name+' '+item.member.middle_name :(item.district?item.district.district_name:(item.organization?item.organization.name:''))}}
            </td>
            <td class="text-center">
              {{ item.member?item.member.contact_no :(item.district?item.district.contact_no:(item.organization?item.organization.contact_no:''))}}
            </td>
            <td class="text-center">
              {{ item.amount}}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-layout>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import moment from "moment";
  import {mdiAccountSearchOutline, mdiPrinter} from '@mdi/js'

  export default {
    setup() {
      return {
        icons: {
          mdiAccountSearchOutline,
          mdiPrinter,
        },
      }
    },
    data() {
      return {
        key: 0,
        can_print: false,
        district_items: [],
        year_items: [],
        district: '',
        year: 'All',
        is_yearly: false,
         month_of: '',
        month_of_items: [],

        officers: [],
        member_items: [],
        unpaid_members: 0,
        totall: 0,

        district_namee: '',
      }
    },
    mounted() {
      this.retrieve_transaction_month()
        .then(response => {
          this.month_of_items = response.data
        })
      this.get_list_of_new_member_items()
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
      ...mapGetters('system_data', ['company_logo']),
      ...mapGetters('authentication', ['branch_id', 'branch', 'branch_address', 'branch_contact_no', 'district_id', 'district_name']),
    },
    watch: {
      branch_id: function () {
        this.can_print = false
        this.month_of = ''
        this.list_of_new_member = []
      }
    },
    methods: {
      ...mapActions('transaction_months', ['retrieve_transaction_month']),
      ...mapActions('district', ['list_of_district']),
      ...mapActions('other_organization', ['list_of_due_others_payment']),
      due_date_format(value, ded) {
        return ded === 1 ? (moment(value).subtract(1, 'year').format('YYYY')) : (moment(value).format('YYYY'))
      },
      get_list_of_new_member_items() {
        this.data_table_loading = true
        if (this.month_of_items.length > 0) {
        var index = this.is_yearly ? this.month_of_items.map(function (x) {
            return x.year
          }).indexOf(this.month_of) : this.month_of_items.map(function (x) {
            return x.id
          }).indexOf(this.month_of)
          if (index != -1) {
            const data = new FormData()
            data.append('remarks', 'ACA FELLOWS');
            data.append('month_of', this.is_yearly ? this.month_of_items[index].year : this.month_of_items[index].month_of);
            data.append('is_yearly', this.is_yearly ? 1 : 0);
            data.append('district_id', this.district_id);
            this.list_of_due_others_payment(data)
              .then((response) => {
                this.member_items = response.data
                this.can_print = this.member_items.length > 0
                this.totall = this.formatPrice(this.member_items.length * 1000)
              })
              .catch(error => {
                console.log(error)
              })
          }
        }
      },
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      print_data() {
        var imgData = this.company_logo
        var array = []
        array.push(
          [
            {text: 'Year Of', alignment: 'center', style: 'label'},
            {text: 'ID', alignment: 'center', style: 'label'},
            {text: 'District/Name', alignment: 'center', style: 'label'},
            {text: 'Contact #', alignment: 'center', style: 'label'},
            {text: 'Amount', alignment: 'center', style: 'label'},
          ]
        )

        if (this.member_items.length > 0) {
          this.member_items.forEach(function (item) {
            array.push(
              [
                {text: item.year_of, alignment: 'center'},
                {text: item.member?item.member.cmf_no:(item.district?item.district.id:(item.organization?item.organization.id:'')), alignment: 'left'},
                {text: item.member?item.member.last_name+', '+item.member.first_name+' '+item.member.middle_name :(item.district?item.district.district_name:(item.organization?item.organization.name:'')), alignment: 'left'},
                {
                  text: item.member?item.member.contact_no :(item.district?item.district.contact_no:(item.organization?item.organization.contact_no:'')),
                  alignment: 'left'
                },
                {
                  text: item.amount,
                  alignment: 'left'
                },
              ]
            )
          })
        } else {
          array.push(
            [
              '----',
              '----',
              '----',
              '----',
              '----',
            ]
          )
        }
        //call pdfmake
        var pdfMake = require('pdfmake/build/pdfmake.js')
        if (pdfMake.vfs == undefined) {
          var pdfFonts = require('pdfmake/build/vfs_fonts.js')
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }
        var docDefinition = {
          pageSize: 'LETTER',
          pageOrientation: 'portrait',
          content: [
            {
              columns: [
                {image: imgData, width: 54, height: 54, style: 'logo'},
                {
                  stack: [
                    'GOODLIFE COMMUNITY CARE FOUNDATION',
                    {text: this.branch_address, style: 'subheader'},
                    {
                      text: 'S.E.C REG. No. NA CONTACT NO.: ' + this.branch_contact_no,
                      style: 'subheader'
                    },
                  ],
                  style: 'header'
                },
              ]
            },
            {text: 'LIST OF ACA FELLOWS', style: 'title'},
            '================================================================================',
            {text: 'Printed as of: ' + moment().format('MMMM D, YYYY'), style: 'printed_label'},
            {
              text: 'District: ' + this.district_namee,
              style: 'main_info'
            },
            {
              text: 'Year of: ' + this.year,
              style: 'main_info'
            },
            {
              text: 'Total: ' + this.totall,
              style: 'main_info'
            },
            ' ',
            {
              style: 'tableExample',
              color: '#444',
              table: {
                widths: [60, 50, 180, 150, 80],
                body: array,
              },
              layout: {
                fillColor: function (rowIndex) {
                  return (rowIndex === 0) ? '#CCCCCC' : null;
                },
              },
            },
            {
              stack: [
                {
                  columns: [
                    {text: 'Prepared By: ', style: 'aa_top_margin'},
                    {text: 'Received By:', style: 'cashier_top_margin'},
                    {text: ''},
                  ]
                },
                {
                  columns: [
                    {text: '', style: 'aa_for'},
                    {text: '', style: 'cashier_for'},
                    {text: ''},
                  ]
                },
                {
                  columns: [
                    {text: '_________________________________', style: 'aa_line'},
                    {text: '_________________________________', style: 'cashier_line'},
                    {text: ''},
                  ]
                },
              ]
            },
            {
              stack: [
                {
                  columns: [
                    {text: 'Verified By: ', style: 'bm_top_margin'},
                    {text: 'Audited By: ', style: 'au_top_margin'},
                  ]
                },
                {
                  columns: [
                    {text: '', style: 'bm_for'},
                    {text: '', style: 'au_for'},
                  ]
                },
                {
                  columns: [
                    {text: '_________________________________', style: 'bm_line'},
                    {text: '_________________________________', style: 'au_line'},
                  ]
                },
                {
                  columns: [
                    {text: 'Branch Manager', style: 'bm_placeholder'},
                    {text: 'Asst. Auditor', style: 'au_placeholder'},
                  ]
                },
              ]
            },
          ],
          footer: {
            columns: [
              {
                text: 'Generated with Goodlife Savings & Credit Cooperative System',
                alignment: 'center',
                style: 'tableExample'
              }
            ]
          },
          styles: {
            header: {
              fontSize: 21,
              bold: true,
              alignment: 'left',
              margin: [6, 6, 0, 20]//[left, top, right, bottom]
            },
            subheader: {
              fontSize: 12
            },
            title: {
              fontSize: 15,
              alignment: 'center',
            },
            logo: {
              alignment: 'center',
              margin: [0, 0, 0, 0]//[left, top, right, bottom]
            },
            printed_label: {
              alignment: 'right',
              fontSize: 9,
              margin: [0, 4, 0, 0]//[left, top, right, bottom]
            },
            main_info: {
              margin: [0, 2, 0, 2],
              fontSize: 10,
            },
            sub_info: {
              margin: [0, 2, 0, 2],
              fontSize: 8,
            },
            tableExample: {
              fontSize: 7,
            },

            aa_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            bm_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            cs_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            aa_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cs_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            bm_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            aa_placeholder: {
              margin: [15, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            aa_for: {
              margin: [0, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cs_for: {
              margin: [2, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_for: {
              margin: [3, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            bm_for: {
              margin: [3, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cashier_placeholder: {
              margin: [26, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            cs_placeholder: {
              margin: [2, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            bm_placeholder: {
              margin: [5, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            au_top_margin: {
              margin: [0, 10, 0, 0],
              alignment: 'left',
              fontSize: 7,
            },
            au_placeholder: {
              margin: [2, 2, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            au_for: {
              margin: [2, 15, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
            au_line: {
              margin: [0, 0, 0, 2],
              alignment: 'left',
              fontSize: 7,
            },
          },
        }
        pdfMake.createPdf(docDefinition).open();
      },
    }
  }
</script>
